// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"9440ad19","91":"36e721fe","218":"7a647201","243":"4c4bdb9c","291":"cf8b133f","389":"4c7be1da","453":"f961762f","473":"f83d361c","545":"4fe67578","579":"2220bcfd","600":"3d46f358","610":"144b697b","628":"6adb7058","872":"ff3175ee"}[chunkId] + ".chunk.js";
};